import $ from 'jquery';
import { initLenis } from '../Lib/Lenis.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SmoothScroll = () => {
  const lenis = initLenis();
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
  ScrollTrigger.config({ ignoreMobileResize: true });
  // ScrollTrigger.normalizeScroll({
  //   allowNestedScroll: true
  // });

  // Lenisインスタンスが破棄されないように保持
  window.lenis = lenis;


  $(document).on('click', '.js-scroll', function(e) {
    e.preventDefault();
    let href = $(this).attr('href');
    if(this.classList.contains('js-purposeScrollLink')) {
      const targetId = this.getAttribute('data-id');
      let target = $(`.js-purposeAnchor[data-id="${targetId}"]`);
      let position = target.offset().top;
      let shift = 0;
      let headerHeight = 0;
      if(window.innerWidth < 961) {
        return;
      } else {
        lenis.scrollTo(position - shift - headerHeight, {
          duration: 0.5,
        });
      }
    } else {
      let target = $(href);
      let position = target.offset().top;
      let headerHeight = document.querySelector('header').offsetHeight;
      let shift = 16;
      lenis.scrollTo(position - shift - headerHeight, {
        duration: 0.5,
      });
    }
  });
}

export default SmoothScroll;